module.exports = __webpack_public_path__ + "static/media/Dedenne_gaussian2.ad92d205.png";